import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faXmark,
  faArrowUpRightAndArrowDownLeftFromCenter,
  faArrowDownLeftAndArrowUpRightToCenter,
} from '@fortawesome/pro-regular-svg-icons'
import { useLabraChatDispatch } from '../../../modules/labraChat/context'
import { closeLabraChatPreview } from '../../../modules/labraChat/actions'
import { LabraChatMessageDocument } from '../../../modules/labraChat/reducer'
import { flyoutAssetUrlFromS3Uri } from '../../../modules/labraChat/api'
import { useStyles } from './ChatDocumentPreview.styles'

/** Opens the browser's built-in PDF viewer fitted to the panel width instead of
 * its default zoom, which is sized for a full window. Chrome honours it; other
 * viewers ignore unknown fragment parameters. */
const PDF_VIEWER_PARAMS = '#view=FitH'

interface ChatDocumentPreviewProps {
  document: LabraChatMessageDocument
  isExpanded: boolean
  onToggleExpanded: () => void
  className?: string
}

export const ChatDocumentPreview: React.FC<ChatDocumentPreviewProps> = ({
  document,
  isExpanded,
  onToggleExpanded,
  className,
}) => {
  const { classes, cx } = useStyles()
  const dispatch = useLabraChatDispatch()

  const src = flyoutAssetUrlFromS3Uri(document.s3_uri)
  if (!src) return null

  return (
    <div className={cx(classes.root, className)}>
      <div className={classes.header}>
        <span className={classes.filename} title={document.filename}>
          {document.filename}
        </span>
        <div className={classes.actions}>
          <button
            type="button"
            className={classes.iconButton}
            onClick={onToggleExpanded}
            title={isExpanded ? 'Show conversation' : 'Hide conversation'}
          >
            <FontAwesomeIcon
              icon={
                isExpanded
                  ? faArrowDownLeftAndArrowUpRightToCenter
                  : faArrowUpRightAndArrowDownLeftFromCenter
              }
            />
          </button>
          <button
            type="button"
            className={classes.iconButton}
            onClick={() => dispatch(closeLabraChatPreview())}
            title="Close preview"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>
      </div>
      <iframe
        className={classes.frame}
        src={`${src}${PDF_VIEWER_PARAMS}`}
        title={document.filename}
      />
    </div>
  )
}
